module.exports = __webpack_public_path__ + "img/jmfq_jbzq4224_1997.prt.6c9feac3.jpg";